import { currentUserAtom } from "@/store/login";
import * as Amplitude from "@amplitude/unified";
import * as Sentry from "@sentry/react";
import { getDefaultStore } from "jotai";

const reportedErrors = new WeakSet<object>();

export const telemetryContextPlugin: Amplitude.Types.EnrichmentPlugin = {
	name: "app-context",
	type: "enrichment",
	execute: async (event) => ({
		...event,
		event_properties: {
			...event.event_properties,
			app: "futchampion",
			env: import.meta.env.MODE,
		},
	}),
};

export function reportAppError(
	error: unknown,
	source: "query" | "mutation" | "boundary" | "router",
	componentStack?: string | null,
) {
	if (error == null) return;
	if (typeof error === "object") {
		if (reportedErrors.has(error)) return;
		reportedErrors.add(error);
	}
	Sentry.captureException(error, {
		tags: { error_source: source },
		contexts: componentStack ? { react: { componentStack } } : undefined,
	});
}

export function watchTelemetryUser() {
	const store = getDefaultStore();
	let previousUserId: string | undefined;
	const syncUser = () => {
		const userId = store.get(currentUserAtom)?.id;
		Sentry.setUser(userId ? { id: userId } : null);
		if (import.meta.env.VITE_AMPLITUDE_API_KEY) {
			if (previousUserId && previousUserId !== userId) Amplitude.reset();
			Amplitude.setUserId(userId);
		}
		previousUserId = userId;
	};
	syncUser();
	return store.sub(currentUserAtom, syncUser);
}
